import BaseSider, { SiderProps as BaseSiderProps } from 'antd/lib/layout/Sider'

export interface SiderProps extends BaseSiderProps {}

export const Sider = (props: SiderProps): JSX.Element => (
  <>
    <BaseSider {...props} />
  </>
)
